import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/**
 * Renders an otpauth:// URI as a QR code. Drawn in the browser, so the authenticator
 * secret is never fetched from a URL that could be logged by a proxy or a server.
 */
export default function QrCode({ value, size = 168, alt = 'QR code' }) {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setSrc(null);
    setFailed(false);
    QRCode.toDataURL(value, { margin: 1, width: size * 2, errorCorrectionLevel: 'M' })
      .then((url) => {
        if (!cancelled) setSrc(url);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });
    return () => {
      cancelled = true;
    };
  }, [value, size]);

  if (failed) return <div className="muted" style={{ fontSize: 12 }}>The QR code could not be drawn — use the key below instead.</div>;

  return (
    <div
      style={{
        width: size,
        height: size,
        background: '#fff',
        borderRadius: 8,
        border: '1px solid var(--border)',
        display: 'grid',
        placeItems: 'center',
        flex: 'none',
      }}
    >
      {src && <img src={src} alt={alt} width={size - 12} height={size - 12} style={{ display: 'block' }} />}
    </div>
  );
}
